import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { Catalogue } from "@singularsystems/neo-react-services";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import Group from "../../../Models/Catalogue/Reporting/Group";
import { AppService, DomainTypes } from "../../../DomainTypes";

export default class GroupStructureCatalogueEntry extends CatalogueEntry<Group> {

    private groupsApiClient = AppService.get(DomainTypes.ApiClients.CatalogueReporting);

    constructor() {
        super("Groups", Group);
    }

    public get editRole() {
        return CatalogueRoles.Groups.Edit;
    }

    public getFetchEndpoint(apiClient: IGenericApiClient) {
        return this.groupsApiClient.getGroups;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return this.groupsApiClient.saveGroups;
    }

    public renderRow(group: Group, meta: Model.TransformMetaType<Group>) {
        return (
            <NeoGrid.RowGroup expandProperty={meta.isExpanded} >
                <NeoGrid.Row>
                    <NeoGrid.Column bind={meta.groupName} />
                    <NeoGrid.Column bind={meta.groupCode} />
                    <Catalogue.ButtonColumn />
                </NeoGrid.Row>
                <NeoGrid.ChildRow>
                    <NeoGrid.Grid items={group.businessUnits} addButton={{ text: "Add Profit Centre", size: "sm" }} >
                        {(businessUnits, childMeta) => (
                            <NeoGrid.RowGroup expandProperty={childMeta.isExpanded}>
                                <NeoGrid.Row title="Profit Centre">
                                    <NeoGrid.Column bind={childMeta.profitCentreName} />
                                    <NeoGrid.Column bind={childMeta.profitCentre} />
                                    <NeoGrid.ButtonColumn showDelete />
                                </NeoGrid.Row>
                                <NeoGrid.ChildRow >
                                    <NeoGrid.Grid items={businessUnits.branches} addButton={{ text: "Add Branch", size: "sm" }} >
                                    {(childB, childBMeta) => (
                                        <NeoGrid.Row title="Branches">
                                            <NeoGrid.Column bind={childBMeta.branchNo} />
                                            <NeoGrid.ButtonColumn showDelete />
                                        </NeoGrid.Row>
                                    )}
                                    </NeoGrid.Grid>
                                </NeoGrid.ChildRow>    
                            </NeoGrid.RowGroup>
                        )}
                    </NeoGrid.Grid>
                </NeoGrid.ChildRow>
            </NeoGrid.RowGroup>
        )
    }
}